import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="M100 59.4167L108.083 78.5L112 87.75L122 88.5834L142.583 90.3334L126.917 103.917L119.333 110.5L121.583 120.333L126.25 140.417L108.583 129.75L100 124.417V59.4167ZM100 16.6667L76.5833 71.9167L16.6667 77L62.1667 116.417L48.5 175L100 143.917L151.5 175L137.833 116.417L183.333 77L123.417 71.9167L100 16.6667Z" />,
  'StarHalf',
  '0 0 200 200',
)
